<!--
  Copyright 2025 The Ground Authors.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
-->

<div class="page">
  <div class="container">
    <ng-container *ngIf="isIos">
      <section i18n="@@app.texts.platformNotSupported.iosMessage">
        <strong>Platform Not Supported:</strong> We've detected you're using an
        iOS device. Currently,
        <strong>Ground is only available for Android.</strong>
      </section>
    </ng-container>

    <ng-container *ngIf="!isIos">
      <section i18n="@@app.texts.launchingGround">
        Launching <strong>Ground</strong>...
      </section>

      <section i18n="@@app.texts.installRedirectMessage">
        If it doesn't open automatically, you will be redirected to Google Play
        to install it.
      </section>

      <section *ngIf="googlePlayId$ | async as googlePlayId">
        <a [href]="playStoreUrl || getPlayStoreUrl(googlePlayId)">
          <img
            [src]="getItOnGooglePlayImageSrc"
            alt="Get it on Google Play"
            i18n-alt="@@app.labels.googlePlayBadgeAlt"
          />
        </a>
      </section>
    </ng-container>
  </div>
</div>
